import { internalNetworkClient } from '@terra/shared-rest-clients-internal-network';
import type {
  CreateInternalNetworkCredentialDto,
  InternalNetworkContract,
  UpdateInternalNetworkCredentialDto,
} from '@terra/shared-contracts-internal-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

type InternalNetworkCredentialTarget = {
  networkId: string;
  credentialId: string;
};

export const internalNetworkCredentialsApi = {
  createInternalNetworkCredential: ({
    networkId,
    body,
  }: {
    networkId: string;
    body: CreateInternalNetworkCredentialDto;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.createCredential>({
      endpointFn: (headers) =>
        internalNetworkClient.createCredential({
          params: { networkId },
          body,
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  updateInternalNetworkCredential: ({
    networkId,
    credentialId,
    body,
  }: InternalNetworkCredentialTarget & {
    body: UpdateInternalNetworkCredentialDto;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.updateCredential>({
      endpointFn: (headers) =>
        internalNetworkClient.updateCredential({
          params: { networkId, credentialId },
          body,
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  deleteInternalNetworkCredential: ({
    networkId,
    credentialId,
  }: InternalNetworkCredentialTarget) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.deleteCredential>({
      endpointFn: (headers) =>
        internalNetworkClient.deleteCredential({
          params: { networkId, credentialId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  verifyInternalNetworkCredential: ({
    networkId,
    credentialId,
  }: InternalNetworkCredentialTarget) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.verifyCredential>({
      endpointFn: (headers) =>
        internalNetworkClient.verifyCredential({
          params: { networkId, credentialId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),
};
